export type MobileNavigationKey = "home" | "learning" | "news" | "settings";

const mobileNavigationRoutes: Record<MobileNavigationKey, ReadonlySet<string>> = {
  home: new Set(["/", "/planner", "/travel"]),
  learning: new Set(["/learning", "/words", "/french", "/ielts"]),
  news: new Set(["/news"]),
  settings: new Set(["/settings"]),
};

function normalizePathname(pathname: string) {
  if (pathname === "/") return pathname;
  return pathname.replace(/\/+$/, "");
}

export function isMobileNavigationActive(
  key: MobileNavigationKey,
  pathname: string,
) {
  return mobileNavigationRoutes[key].has(normalizePathname(pathname));
}
